<template>
  <div class="ms-form ms-form--narrow">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomInput label="Комментарий" type="textarea" rows="4" :required="true" :value="this.comment"
          @change_input="(value) => (this.comment = value)" />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "provider-request-service-comment",
  components: { CustomInput, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      comment: this.data?.body?.comment || "",
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      await this.data?.onSubmit(this.comment);
      this.loading = false;
    },
  },
};
</script>
